import { render, staticRenderFns } from "./ResourceDown.vue?vue&type=template&id=e152244a&scoped=true&"
import script from "./ResourceDown.vue?vue&type=script&lang=js&"
export * from "./ResourceDown.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDown.vue?vue&type=style&index=0&id=e152244a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e152244a",
  null
  
)

export default component.exports